import { TabValidationData } from '../../types';

/**
 * Checks if provided input values are valid for Teams to allow saving a new tab.
 *
 * @param {TabValidationData} _ {@link TabValidationData} object
 * @returns Object with boolean fields that tells which validation succeeded/failed.
 */
export const validateTeamsSettings = (
  tabConfigured: boolean,
  {
    projectId,
    services,
    connections,
    connectionName,
    tabName,
    iModel,
  }: TabValidationData
) => {
  const validations = {
    connectionsValid: false,
    projectsValid: false,
    serviceValid: false,
    iModelValid: false,
  };

  const projectsValid = (): boolean => projectId !== '' && projectId !== '0';
  const servicesValid = (): boolean => services.length > 0;
  const connectionsValid = (): boolean =>
    connections !== undefined &&
    connectionName !== undefined &&
    (connections.map(c => c.name).includes(connectionName) ||
      connectionName === 'Share' ||
      connectionName === 'All Connections');
  const iModelValid = (): boolean =>
    !!iModel &&
    !!iModel.iModelId &&
    !!iModel.namedVersionId &&
    !!iModel.defaultViewId;

  validations.projectsValid = projectsValid();
  validations.serviceValid =
    validations.projectsValid &&
    (tabName?.length > 3 || tabConfigured) &&
    servicesValid();
  validations.connectionsValid = validations.serviceValid && connectionsValid();
  validations.iModelValid = iModelValid();

  return validations;
};
